import { useState } from "react";
import { toast } from "sonner";
import { Download, UserX } from "lucide-react";
import { api, errMsg, saveBlob } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function UserRgpdActions({ user, users, isSelf, onDone }) {
  const [open, setOpen] = useState(false);
  const [heir, setHeir] = useState("");
  const [confirm, setConfirm] = useState("");
  const exportData = async () => {
    try { const r = await api.get(`/admin/users/${user.user_id}/data-export`, { responseType: "blob" }); saveBlob(r.data, `donnees_${user.email}.json`); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const erase = async () => {
    try {
      const { data } = await api.post(`/admin/users/${user.user_id}/erase`, { transfer_to: heir });
      toast.success(`Compte effacé · ${data.files_transferred} documents transférés`);
      if (!data.login_deleted) toast.warning("La connexion n'a pas pu être supprimée chez le fournisseur d'identité : désactivez-la depuis votre profil Clerk ou réessayez.");
      setOpen(false); onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const heirs = users.filter((u) => u.active && u.user_id !== user.user_id);
  return (
    <div className="flex items-center gap-1">
      <Button variant="ghost" size="icon" className="h-8 w-8" aria-label="Exporter ses données" title="Exporter ses données (RGPD)" onClick={exportData} data-testid={`user-export-${user.user_id}`}><Download className="h-4 w-4" /></Button>
      {!isSelf && <Button variant="ghost" size="icon" className="h-8 w-8 text-red-600" aria-label="Effacer le compte" title="Effacer le compte (RGPD)" onClick={() => setOpen(true)} data-testid={`user-erase-${user.user_id}`}><UserX className="h-4 w-4" /></Button>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="erase-dialog">
          <DialogTitle className="font-display">Effacer le compte de {user.name}</DialogTitle>
          <DialogDescription>Le compte et ses données personnelles sont supprimés définitivement ; son nom est remplacé par « Utilisateur supprimé » dans l'historique. Ses documents professionnels sont transférés au collègue choisi. Les validations comptables sont conservées (obligation légale).</DialogDescription>
          <Select value={heir} onValueChange={setHeir}>
            <SelectTrigger data-testid="erase-heir-select"><SelectValue placeholder="Transférer ses documents à…" /></SelectTrigger>
            <SelectContent>{heirs.map((u) => <SelectItem key={u.user_id} value={u.user_id}>{u.name} ({u.email})</SelectItem>)}</SelectContent>
          </Select>
          <input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Tapez EFFACER pour confirmer" className="border rounded-md h-10 px-3 text-sm" data-testid="erase-confirm-input" />
          <Button variant="destructive" disabled={!heir || confirm !== "EFFACER"} onClick={erase} data-testid="erase-submit-btn">Effacer définitivement</Button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
